import React, { useState } from 'react';
import Layout from '../../components/Layout';
import DataTable from 'react-data-table-component';
import * as XLSX from 'xlsx';
import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { get } from '../../controllers/apiController';

const Reklamlar = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [ads, setAds] = useState([]);

    useEffect(() => {
        document.title = "Reklamlar | LEVELUP CRM";

        const getData = async () => {
            try {
                const response = await get("/ads/active");

                setAds(response.data);

                setIsLoading(false);
            } catch (err) {
                toast.error("Veriler alınırken bir hata oluştu!");
            }
        }

        getData();
    }, []);

    const paginationComponentOptions = {
        rowsPerPageText: 'Sayfa başına satır:',
        rangeSeparatorText: 'toplam',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Tümü',
        firstPageText: 'İlk',
        previousPageText: 'Önceki',
        nextPageText: 'Sonraki',
        lastPageText: 'Son',
        noRowsPerPage: false,
    };

    const customStyles = {
        noData: {
            style: {
                padding: '24px',
                textAlign: 'center',
            },
        },
        rows: {
            style: {
                backgroundColor: 'transparent',
                '&:last-child': {
                    backgroundColor: '#f8f9fa'
                }
            }
        }
    };

    const toplamHesapla = () => {
        return {
            ad_name: "TOPLAM",
            impressions: ads.reduce((acc, curr) => acc + parseFloat(curr.impressions), 0),
            reach: ads.reduce((acc, curr) => acc + parseFloat(curr.reach), 0),
            clicks: ads.reduce((acc, curr) => acc + parseFloat(curr.clicks), 0),
            cpc: (ads.reduce((acc, curr) => acc + parseFloat(curr.cpc), 0) / ads.length).toFixed(2),
            // formSayisi: ads.reduce((acc, curr) => acc + parseFloat(curr.formSayisi), 0).toLocaleString('tr-TR'),
            cost_per_inline_link_click: (ads.reduce((acc, curr) => acc + parseFloat(curr.cost_per_inline_link_click), 0) / ads.length).toFixed(2),
            spend: ads.reduce((acc, curr) => acc + parseFloat(curr.spend), 0).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        };
    };

    const columns = [
        {
            name: 'KAMPANYA ADI',
            sortable: true,
            cell: row => (
                <span className="text-truncate-1-line fw-semibold">{row.ad_name}</span>
            )
        },
        {
            name: 'GÖSTERİMLER',
            cell: row => (
                <span className={`text-truncate-1-line ${row.ad_name === "TOPLAM" ? "fw-semibold" : ""}`}>{row.impressions.toLocaleString('tr-TR')}</span>
            )
        },
        {
            name: 'ERİŞİMLER',
            cell: row => (
                <span className={`text-truncate-1-line ${row.ad_name === "TOPLAM" ? "fw-semibold" : ""}`}>{row.reach.toLocaleString('tr-TR')}</span>
            )
        },
        {
            name: 'TIKLAMALAR',
            cell: row => (
                <span className={`text-truncate-1-line ${row.ad_name === "TOPLAM" ? "fw-semibold" : ""}`}>{row.clicks}</span>
            )
        },
        {
            name: 'TBM',
            cell: row => (
                <span className={`text-truncate-1-line ${row.ad_name === "TOPLAM" ? "fw-semibold" : ""}`}>{parseFloat(row.cpc).toFixed(2)}</span>
            )
        },
        // {
        //     name: 'FORM SAYISI',
        //     cell: row => (
        //         <span className={`text-truncate-1-line ${row.ad_name === "TOPLAM" ? "fw-semibold" : ""}`}>{row.formSayisi}</span>
        //     )
        // },
        {
            name: 'SONUÇ BAŞINA ÜCRET',
            cell: row => (
                <span className={`text-truncate-1-line ${row.ad_name === "TOPLAM" ? "fw-semibold" : ""}`}>₺{row.ad_name !== "TOPLAM" ? parseFloat(row.cost_per_inline_link_click).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : parseFloat(row.cost_per_inline_link_click).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
            )
        },
        {
            name: 'HARCAMA',
            cell: row => (
                <span className="text-truncate-1-line fw-semibold">₺{row.ad_name !== "TOPLAM" ? parseFloat(row.spend).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : row.spend}</span>
            )
        }
    ];

    const handleExport = () => {
        const data = [...ads, toplamHesapla()];

        // Excel için verileri sütun başlıklarına göre yeniden düzenleme
        const excelData = data.map(row => {
            return {
                'KAMPANYA ADI': row.ad_name,
                'GÖSTERİMLER': row.impressions,
                'ERİŞİMLER': row.reach,
                'TIKLAMALAR': row.clicks,
                'TBM': row.cpc,
                'FORM SAYISI': row.formSayisi,
                'SONUÇ BAŞINA ÜCRET': row.cost_per_inline_link_click,
                'HARCAMA': `₺${row.spend}`
            };
        });

        const ws = XLSX.utils.json_to_sheet(excelData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Reklamlar");

        // Sütun genişliklerini ayarlama
        const wscols = [
            { wch: 30 }, // KAMPANYA ADI
            { wch: 15 }, // GÖSTERİMLER
            { wch: 15 }, // ERİŞİMLER
            { wch: 15 }, // clicks
            { wch: 10 }, // TBM
            // {wch: 15}, // FORM SAYISI
            { wch: 20 }, // SONUÇ BAŞINA ÜCRET
            { wch: 15 }  // HARCAMA
        ];
        ws['!cols'] = wscols;

        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `Reklamlar_${new Date().toLocaleString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }).replace(/\//g, '.').replace(':', '.')}.xlsx`;
        link.click();
        window.URL.revokeObjectURL(url);
    };

    return (
        <Layout>
            <main className="nxl-container">
                <div className="nxl-content">
                    <div className="page-header">
                        <div className="page-header-left d-flex align-items-center">
                            <div className="page-header-title">
                                <h5 className="m-b-10">LEVELUP CRM</h5>
                            </div>
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><a href="./">Anasayfa</a></li>
                                <li className="breadcrumb-item">Reklamlar</li>
                            </ul>
                        </div>
                        <div className="page-header-right ms-auto">
                            <div className="page-header-right-items">
                                <div className="d-flex d-md-none">
                                    <a href="javascript:void(0)" className="page-header-right-close-toggle">
                                        <i className="feather-arrow-left me-2"></i>
                                        <span>Geri</span>
                                    </a>
                                </div>
                                <div className="d-flex align-items-center gap-2 page-header-right-items-wrapper">
                                    <a href="javascript:void(0);" onClick={handleExport} className="btn btn-icon btn-light-brand">
                                        <i className="feather-printer"></i>
                                    </a>
                                </div>
                            </div>
                            <div className="d-md-none d-flex align-items-center">
                                <a href="javascript:void(0)" className="page-header-right-open-toggle">
                                    <i className="feather-align-right fs-20"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="main-content">
                        <div className="row">
                            <div className="col-xxl-12 col-md-12">
                                <div className="card stretch stretch-full">
                                    <div className="card-header">
                                        <h5 className="card-title">Tüm Reklamlar</h5>
                                    </div>
                                    <div className="card-body custom-card-action p-2">
                                        { isLoading ? (
                                            <div className="w-100 d-flex align-items-center justify-content-center spinner-wrapper">
                                                <div class="spinner-border text-primary" role="status">
                                                    <span class="visually-hidden">Yükleniyor...</span>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="table-responsive mb-3">
                                                <DataTable
                                                    columns={columns}
                                                    data={[...ads, toplamHesapla()]}
                                                    className="table table-hover mb-0"
                                                    pagination
                                                    responsive
                                                    noDataComponent="Görüntülenecek kayıt bulunamadı"
                                                    paginationComponentOptions={paginationComponentOptions}
                                                    customStyles={customStyles}
                                                    paginationPerPage={10}
                                                    paginationRowsPerPageOptions={[10, 25, 50, 100]}
                                                />
                                            </div>
                                        ) }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </Layout>
    );
};

export default Reklamlar;
